import React from 'react';
import { IconType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import DeviceIconCommon from '../../../../../components/device-icon';
import { availableIcon } from './available-icons';

type DeviceIconProps = {
  iconType?: IconType;
};

export const DeviceIcon: React.FC<DeviceIconProps> = ({ iconType }) => {
  const icon = iconType ? availableIcon[iconType] : availableIcon[IconType.Unknown];

  return <DeviceIconCommon icon={icon} />;
};
